// CheckoutPage.js
import React, { useEffect, useState } from "react";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.
const stripePromise = loadStripe("pk_test_51O2hqKGX1i6I66OXf7tZ6rMfOV5RuuQ3xU1GoYyDMgQHKN4zZ50Rz8z4QFWbuQEpOX3LkldzEj9hXliatgf2GkwY00BaU5blax");

const CheckoutPage = () => {
    const [clientSecret, setClientSecret] = useState("");
    const { locale, t } = useI18n();

    useEffect(() => {
      
      // Create PaymentIntent as soon as the page loads
      fetch("http://127.0.0.1:5000/create-payment-intent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: "xl-tshirt" }] }),
      })
        .then((res) => res.json())
        .then((data) => setClientSecret(data.clientSecret));
    }, []);
  
    const appearance = {
      theme: 'stripe',
    };
    const options = {
      clientSecret,
      appearance,
      locale: locale === 'zh-CN' ? 'zh' : locale === 'zh-TW' ? 'zh-HK' : locale,
    };

  return (
    <div className="checkout-page">
    <Seo
      title={t('cart.checkout')}
      description={t('payment.seoDescription')}
      path="/checkout"
      noindex
    />
    {clientSecret && (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutForm />
        </Elements>
    )}
    </div>
  );
};

export default CheckoutPage;
